export const COUNTRIES = [
  { value: "", label: "--Select Country--" },
  { value: "US", label: "United States" },
  { value: "CA", label: "Canada" },
  // Add more countries as needed
] as const;
